/* PawTote global scripts */
(function () {
  'use strict';

  var R = window.routes || {
    cart_add_url: '/cart/add',
    cart_change_url: '/cart/change',
    cart_update_url: '/cart/update',
    cart_url: '/cart',
    root_url: '/'
  };

  /* ================= Mobile nav (hamburger) ================= */
  document.querySelectorAll('[data-nav-toggle]').forEach(function (btn) {
    var nav = document.getElementById(btn.getAttribute('aria-controls')) || document.querySelector('.header__nav');
    if (!nav) return;
    btn.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    /* Close the menu when a link is tapped */
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        nav.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      });
    });
  });

  /* ================= Product gallery thumbnails ================= */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-main-image]');
    gallery.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.dataset.src;
        main.srcset = '';
        gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ================= Bundle selector drives quantity ================= */
  /* Copies the ticked bundle (1/2/3) into the form's quantity field. Returns the
     bundle quantity, or null when the form has no bundle selector. */
  function syncBundleQty(form) {
    var checked = form.querySelector('[data-bundles] input[type="radio"]:checked');
    var qty = form.querySelector('input[name="quantity"]');
    if (checked && qty) qty.value = checked.value;
    return checked ? checked.value : null;
  }

  document.querySelectorAll('[data-bundles]').forEach(function (wrap) {
    var form = wrap.closest('form');
    if (!form) return;
    wrap.querySelectorAll('input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () { syncBundleQty(form); });
    });
    /* The browser restores the ticked bundle on reload / back without the quantity: resync */
    syncBundleQty(form);
    window.addEventListener('pageshow', function () { syncBundleQty(form); });
  });

  /* ================= Before / After comparison slider ================= */
  document.querySelectorAll('[data-before-after]').forEach(function (ba) {
    var frame = ba.querySelector('.ba__frame');
    var range = ba.querySelector('.ba__range');

    function setPos(pct) {
      pct = Math.max(0, Math.min(100, pct));
      frame.style.setProperty('--ba-pos', pct + '%');
      range.value = pct;
    }

    range.addEventListener('input', function () { setPos(parseFloat(range.value)); });

    function pointerPct(e) {
      var rect = frame.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      return (x / rect.width) * 100;
    }
    var dragging = false;
    frame.addEventListener('pointerdown', function (e) { dragging = true; setPos(pointerPct(e)); });
    window.addEventListener('pointermove', function (e) { if (dragging) setPos(pointerPct(e)); });
    window.addEventListener('pointerup', function () { dragging = false; });
  });

  /* ================= Reviews carousel dots ================= */
  document.querySelectorAll('[data-reviews]').forEach(function (carousel) {
    var dotsWrap = carousel.parentElement.querySelector('[data-reviews-dots]');
    if (!dotsWrap) return;
    var slides = carousel.querySelectorAll('.review-slide');
    if (slides.length < 2) return;
    slides.forEach(function (slide, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = i === 0 ? 'is-active' : '';
      dot.addEventListener('click', function () {
        carousel.scrollTo({ left: slide.offsetLeft - carousel.offsetLeft, behavior: 'smooth' });
      });
      dotsWrap.appendChild(dot);
    });
    carousel.addEventListener('scroll', function () {
      var idx = Math.round(carousel.scrollLeft / carousel.clientWidth);
      dotsWrap.querySelectorAll('button').forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    }, { passive: true });
  });

  /* ================= Puppy photo upload: preview + validation ================= */
  document.querySelectorAll('[data-upload]').forEach(function (upload) {
    var input = upload.querySelector('input[type="file"]');
    var preview = upload.querySelector('[data-upload-preview]');
    var img = upload.querySelector('[data-upload-img]');
    var nameEl = upload.querySelector('[data-upload-name]');
    var removeBtn = upload.querySelector('[data-upload-remove]');
    var error = upload.querySelector('[data-upload-error]');
    var prompt = upload.querySelector('[data-upload-prompt]');
    var form = upload.closest('form');
    var MAX_BYTES = 20 * 1024 * 1024;

    if (form) form.setAttribute('enctype', 'multipart/form-data');

    function reset() {
      input.value = '';
      preview.classList.remove('has-image');
      if (prompt) prompt.style.display = '';
      if (img.src) { URL.revokeObjectURL(img.src); img.removeAttribute('src'); }
    }

    input.addEventListener('change', function () {
      error.style.display = 'none';
      var file = input.files[0];
      if (!file) { reset(); return; }
      if (!/^image\//.test(file.type)) {
        error.textContent = 'Please choose an image file (JPG, PNG or WEBP).';
        error.style.display = 'block';
        reset();
        return;
      }
      if (file.size > MAX_BYTES) {
        error.textContent = 'That photo is over 20MB. Please choose a smaller one.';
        error.style.display = 'block';
        reset();
        return;
      }
      img.src = URL.createObjectURL(file);
      if (nameEl) nameEl.textContent = file.name;
      preview.classList.add('has-image');
      if (prompt) prompt.style.display = 'none';
    });

    if (removeBtn) {
      removeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        reset();
      });
    }
  });

  function uploadsValid(form) {
    var ok = true;
    form.querySelectorAll('[data-upload]').forEach(function (upload) {
      var input = upload.querySelector('input[type="file"]');
      var error = upload.querySelector('[data-upload-error]');
      if (input.hasAttribute('data-required') && !input.files.length) {
        error.textContent = upload.dataset.errRequired || "Please upload your pup's photo first.";
        error.style.display = 'block';
        upload.scrollIntoView({ behavior: 'smooth', block: 'center' });
        ok = false;
      }
    });
    return ok;
  }

  /* ================= Cart drawer ================= */
  var drawerRoot = document.querySelector('[data-cart-drawer]');

  function openDrawer() {
    if (!drawerRoot) return;
    drawerRoot.classList.add('is-open');
    document.body.classList.add('drawer-lock');
  }

  function closeDrawer() {
    if (!drawerRoot) return;
    drawerRoot.classList.remove('is-open');
    document.body.classList.remove('drawer-lock');
  }

  /* ================= Add-on limit: max 1 Shipping Protection + max 1 100-Day Warranty ================= */
  /* Product handles of the add-ons that may appear only once (quantity 1) in a cart. */
  var LIMITED_ADDON_HANDLES = ['shipping-protection', '30-day-warranty'];

  function isLimitedAddon(item) {
    return !!item && LIMITED_ADDON_HANDLES.indexOf(item.handle) !== -1;
  }

  /* Caps each limited add-on at quantity 1 (and removes any duplicate line of it).
     Resolves to { cart, changed }. Other products are never touched. */
  function enforceAddonLimits(cart) {
    var seen = {};
    var updates = {};
    var changed = false;
    (cart.items || []).forEach(function (item) {
      if (!isLimitedAddon(item)) return;
      if (seen[item.handle]) { updates[item.key] = 0; changed = true; return; }
      seen[item.handle] = true;
      if (item.quantity > 1) { updates[item.key] = 1; changed = true; }
    });
    if (!changed) return Promise.resolve({ cart: cart, changed: false });
    return fetch(R.cart_update_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add-on limit update failed');
        return r.json();
      })
      .then(function (fixed) { return { cart: fixed, changed: true }; });
  }

  function fetchCart() {
    return fetch(R.cart_url + '.js')
      .then(function (r) { return r.json(); })
      .then(enforceAddonLimits);
  }

  function refreshCart(open) {
    /* Enforce the add-on limit first, so the drawer always renders the corrected cart */
    return fetchCart().then(function (res) {
      return fetch(R.root_url + '?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (sections) { return [sections, res.cart]; });
    }).then(function (results) {
      var sectionHtml = results[0]['cart-drawer'];
      var cart = results[1];
      if (drawerRoot && sectionHtml) {
        var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
        var freshInner = doc.querySelector('[data-drawer-inner]');
        var currentInner = drawerRoot.querySelector('[data-drawer-inner]');
        if (freshInner && currentInner) currentInner.innerHTML = freshInner.innerHTML;
      }
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      if (open) openDrawer();
    });
  }

  if (drawerRoot) {
    /* Open from header cart icon */
    document.querySelectorAll('[data-cart-open]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        refreshCart(true);
      });
    });

    /* Delegated events inside the drawer (content is re-rendered) */
    drawerRoot.addEventListener('click', function (e) {
      var closeEl = e.target.closest('[data-drawer-close]');
      if (closeEl) { e.preventDefault(); closeDrawer(); if (closeEl.href) window.location = closeEl.href; return; }

      var stepBtn = e.target.closest('[data-qty-change]');
      if (stepBtn) {
        if (stepBtn.disabled) return;
        var newQty = Math.max(0, parseInt(stepBtn.dataset.qty, 10) + parseInt(stepBtn.dataset.qtyChange, 10));
        var maxQty = parseInt(stepBtn.dataset.max, 10);
        if (maxQty && newQty > maxQty) return; /* limited add-on: cannot go above 1 */
        changeLine(parseInt(stepBtn.dataset.line, 10), newQty);
        return;
      }

      var removeBtn = e.target.closest('[data-qty-set]');
      if (removeBtn) {
        changeLine(parseInt(removeBtn.dataset.line, 10), parseInt(removeBtn.dataset.qtySet, 10));
      }
    });

    drawerRoot.addEventListener('change', function (e) {
      var toggle = e.target.closest('[data-tip-toggle]');
      var variantSelect = e.target.closest('[data-tip-variant]');
      var tipWrap = e.target.closest('[data-tip]');
      if (!tipWrap) return;

      var toggleEl = tipWrap.querySelector('[data-tip-toggle]');
      var selectEl = tipWrap.querySelector('[data-tip-variant]');
      var allVariants = (toggleEl.dataset.variants || '').split(',').filter(Boolean);

      if (toggle || (variantSelect && toggleEl.checked)) {
        /* Clear any tip variants, then add the selected one if toggled on */
        var updates = {};
        allVariants.forEach(function (id) { updates[id] = 0; });
        fetch(R.cart_update_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          if (toggleEl.checked) {
            return fetch(R.cart_add_url + '.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: parseInt(selectEl.value, 10), quantity: 1 })
            });
          }
        }).then(function () { refreshCart(false); });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  function changeLine(line, quantity) {
    fetch(R.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function () { refreshCart(false); });
  }

  /* ================= Add-to-cart: AJAX (supports file upload via FormData) ================= */
  document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      /* Quantity always follows the ticked bundle (also for the native-submit fallback) */
      var bundleQty = syncBundleQty(form);
      if (!uploadsValid(form)) { e.preventDefault(); return; }
      if (!drawerRoot || !window.fetch || !window.FormData) return; /* native submit fallback */
      e.preventDefault();

      var btn = form.querySelector('button[name="add"]');
      var originalText;
      if (btn) { originalText = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…'; }

      var fd = new FormData(form);
      fd.delete('bundle');
      if (bundleQty) fd.set('quantity', bundleQty);

      fetch(R.cart_add_url + '.js', { method: 'POST', body: fd })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return fetch(R.cart_url + '.js').then(function (res) { return res.json(); });
        })
        .then(function (cart) {
          /* Limited add-ons already in the cart are not added again (max 1 each) */
          var limitedInCart = {};
          (cart.items || []).forEach(function (item) {
            if (isLimitedAddon(item)) limitedInCart[item.variant_id] = true;
          });
          /* Add checked add-ons one by one, always quantity 1 */
          var chain = Promise.resolve();
          form.querySelectorAll('[data-addon-variant]:checked').forEach(function (cb) {
            if (limitedInCart[parseInt(cb.dataset.addonVariant, 10)]) return;
            chain = chain.then(function () {
              return fetch(R.cart_add_url + '.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: parseInt(cb.dataset.addonVariant, 10), quantity: 1 })
              });
            });
          });
          return chain;
        })
        .then(function () { return refreshCart(true); })
        .catch(function () { form.submit(); })
        .then(function () {
          if (btn) { btn.disabled = false; btn.textContent = originalText; }
        });
    });
  });

  /* ================= Add-on limit on page load ================= */
  /* Catches carts changed by non-AJAX posts (e.g. the cart page "Update cart" form). */
  if (window.fetch) {
    fetchCart().then(function (res) {
      if (!res.changed) return;
      if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
      if (drawerRoot) refreshCart(false);
    }).catch(function () {});
  }
})();
